"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PollerManager = void 0;
var immutable_1 = require("immutable");
var BehaviorSubject_1 = require("rxjs/BehaviorSubject");
var Observable_1 = require("rxjs/Observable");
require("rxjs/add/operator/startWith");
require("rxjs/add/operator/mergeMap");
require("rxjs/add/operator/repeat");
require("rxjs/add/operator/delay");
require("rxjs/add/operator/retryWhen");
require("rxjs/add/observable/timer");
require("rxjs/add/observable/fromPromise");
require("rxjs/add/observable/empty");
require("rxjs/add/operator/map");
require("rxjs/add/operator/switchMap");
require("rxjs/add/operator/share");
var types_1 = require("../types");
var Poller_1 = __importDefault(require("./Poller"));
var PollerManager = /** @class */ (function () {
    function PollerManager(options) {
        var _a;
        var _this = this;
        this.pollers = immutable_1.OrderedMap();
        this.interval = ((options && options.intervals) || 30) * 1000;
        this.init = this.init.bind(this);
        this.selectBehaviorByInterval = this.selectBehaviorByInterval.bind(this);
        this.pollingIntervals = (_a = {},
            _a[types_1.App.PollingTrigger.Reschedule] = this.interval,
            _a[types_1.App.PollingTrigger.Stop] = 0,
            _a);
        this.polling$ = new BehaviorSubject_1.BehaviorSubject(types_1.App.PollingTrigger.Stop);
        this.intervalObserver$ = this.polling$
            .map(function (trigger) { return _this.pollingIntervals[trigger]; })
            .switchMap(this.selectBehaviorByInterval)
            .share();
        this.intervalObserver$.subscribe(function () { return null; });
    }
    PollerManager.prototype.init = function () {
        this.polling$.next(types_1.App.PollingTrigger.Reschedule);
    };
    PollerManager.prototype.stop = function () {
        this.polling$.next(types_1.App.PollingTrigger.Stop);
    };
    PollerManager.prototype.getIntervalObserve = function () {
        return this.intervalObserver$;
    };
    PollerManager.prototype.create = function (options) {
        var pollerArgs = __assign({}, options);
        if (this.polling$.value === types_1.App.PollingTrigger.Stop) {
            pollerArgs.changeActiveState = this.init;
        }
        var newPoller = new Poller_1.default(pollerArgs);
        this.pollers = this.pollers.set(options.name, newPoller);
        return newPoller;
    };
    PollerManager.prototype.remove = function (poller) {
        if (poller instanceof Poller_1.default)
            this.pollers = this.pollers.remove(poller.name);
        this.pollers = this.pollers.remove(poller);
    };
    PollerManager.prototype.get = function (pollerName) {
        return this.pollers.get(pollerName);
    };
    PollerManager.prototype.selectBehaviorByInterval = function (interval) {
        var _this = this;
        return interval > 0
            ? Observable_1.Observable.timer(interval)
                .mergeMap(function () {
                return Observable_1.Observable.fromPromise(_this.executePollers({
                    isRepeat: true,
                    isPolling: true,
                    isLoadMore: false,
                }));
            })
                .repeat()
                .retryWhen(function (err$) { return err$.delay(interval * 2); })
            : Observable_1.Observable.empty();
    };
    PollerManager.prototype.executePollers = function (options) {
        return Promise.all(this.pollers
            .filter(function (poller) { return poller.isActive; })
            .map(function (poller) { return poller.requestContent(options); })
            .toList()
            .toArray());
    };
    return PollerManager;
}());
exports.PollerManager = PollerManager;
var PollerManagerInstance = null;
function getPollerManager() {
    if (!PollerManagerInstance)
        PollerManagerInstance = new PollerManager();
    return PollerManagerInstance;
}
if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
    // eslint-disable-next-line
    window['__pollers'] = getPollerManager();
}
exports.default = getPollerManager;
//# sourceMappingURL=PollerManager.js.map